var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container-layout"},[_c('el-container',{ref:"contentContainer"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{class:_vm.contentWrapperClass},[_c('router-view')],1)])],1),_c('div',{ref:"footer",attrs:{"id":"footer"}},[_c('DsFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }